import request from './base/http';

//答卷列表操作

export default {
  // 保存接口
  getDetailAcCard(data) {
    return request({
      method: 'get',
      url: '/AcCard/GetDetailAcCard',
      params: data,
    });
  },
  addCard(data) {
    return request({
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      url: '/CardQuest/Add_Card',
      data,
    });
  },
};
